export default __webpack_public_path__ + "static/media/816.b1df3e30.png";